// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.div_menu {
  display: flex;
  flex-direction: column;
  height: 620px;
  width: 80px;
  border-right: 1px solid var(--cor-cinzaMargin);
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.container {
  display: flex;
  flex-direction: row;
}

.div_icones img {
  width: 3em;
  margin: 0.3em;
  margin-left: 0.8em;
  border: solid 2.5px transparent;
}

.div_icones img:hover {
  border: solid 2.5px var(--cor-roxoEscuro);
  cursor: pointer;
  border-radius: 13px;
}

.btn_sair img {
  margin: 0.7em;
  padding: 10.5px;
  cursor: pointer;
  margin-bottom: 1.5em;
  border: solid 2.5px transparent;
}

.btn_sair img:hover {
  border: solid 2.5px var(--cor-vermelho);
  cursor: pointer;
  border-radius: 10px;
}

.sair {
  border: none;
  background: none;
  cursor: pointer;
}

.titulo {
  font-family: "Roboto";
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  left: 31%;
}

.botoesdaModal {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 10%;
}

.btnSairDaModal {
  left: 90%;
  margin-bottom: 100%;
  display: flex;
  position: absolute;
  z-index: 100;
}
`, "",{"version":3,"sources":["webpack://./src/cabecalho/TelasNavegacao.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".div_menu {\n  display: flex;\n  flex-direction: column;\n  height: 620px;\n  width: 80px;\n  border-right: 1px solid var(--cor-cinzaMargin);\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.container {\n  display: flex;\n  flex-direction: row;\n}\n\n.div_icones img {\n  width: 3em;\n  margin: 0.3em;\n  margin-left: 0.8em;\n  border: solid 2.5px transparent;\n}\n\n.div_icones img:hover {\n  border: solid 2.5px var(--cor-roxoEscuro);\n  cursor: pointer;\n  border-radius: 13px;\n}\n\n.btn_sair img {\n  margin: 0.7em;\n  padding: 10.5px;\n  cursor: pointer;\n  margin-bottom: 1.5em;\n  border: solid 2.5px transparent;\n}\n\n.btn_sair img:hover {\n  border: solid 2.5px var(--cor-vermelho);\n  cursor: pointer;\n  border-radius: 10px;\n}\n\n.sair {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.titulo {\n  font-family: \"Roboto\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  z-index: 1;\n  left: 31%;\n}\n\n.botoesdaModal {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  width: 100%;\n  margin-top: 10%;\n}\n\n.btnSairDaModal {\n  left: 90%;\n  margin-bottom: 100%;\n  display: flex;\n  position: absolute;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
